import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import { connect } from "react-redux";

import FontAwesomeIcon from "./Icon";
import ToggleButton from "../../PlayerButtons/ToggleButton";
import VolumeGreen from "../Innovators/VolumeGreen";
import VolumeRed from "../Mentors/VolumeRed";
import Volume from "../Employers/Volume";
import ProgressGreen from "../Innovators/ProgressGreen";
import ProgressRed from "../Mentors/ProgressRed";
import Progress from "../Employers/Progress";

import DiscussionPost from "../Innovators/DiscussionPost";
import MentorStreamPost from "../Mentors/MentorStreamPost";
import MentorCoursePost from "../Mentors/MentorCoursePost";
import JobStreamPost from "../Employers/JobStreamPost";

import Blocks from "./Blocks";

import { addReaction, addPostComment } from "../../../actions/post";
import PostCommentsItem from "./PostCommentsItem";
import ProfileArticlePostComment from "../Innovators/ProfileArticlePostComment";
import MentorProfileCommentsItem from "../Mentors/MentorProfileCommentsItem";
import EmployerCommentsItem from "../Employers/EmployerCommentsItem";
import PublishedArticle from "./PublishedArticle";
import { evaluate } from "../../../utilities/props";

export const PostItem = ({
  auth: { user },
  addReaction,
  post: {
    _id,
    role,
    channelid,
    type,
    text,
    title,
    avatar,
    image,
    articleimage,
    keywords,
    blocks,
    video,
    description,
    firstname,
    lastname,
    companyname,
    jobtitle,
    location,
    likes,
    comments,
    date,
  },
  addPostComment,
  time,
  videoduration,
}) => {
  const [showComments, setShowComments] = useState(false);
  const [comment, setComment] = useState("");
  const [showArticle, setshowArticle] = useState(false);
  const [showOverlay, setshowOverlay] = useState(false);
  const [showModal, setShowModal] = useState(false);

  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  return (
    <Fragment>
      {type === "innovatorpost" && user && user.role === "innovator" && (
        <div className="profile-post">
          <div className="post-date">
            {!showModal && <i className="far fa-clock mr-5 mt-2 green"></i>}
            {!showModal && <Moment format="MM/DD/YYYY">{date}</Moment>}
            {showModal && <div></div>}
            <i
              className="fas fa-ellipsis-v fa-lg post-info green"
              onClick={() => {
                if (showModal) {
                  setShowModal(false);
                } else {
                  setShowModal(true);
                }
              }}
            ></i>
          </div>
          <div className="post-header">
            <Link to={`/${channelid}`}>
              <div className="online-avi-container">
                <div className="avi-color-border green">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                    className="post-avi"
                  />
                </div>
              </div>
            </Link>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="side-container-user-item">{jobtitle}</li>
              </ul>
            </div>
          </div>
          {image && (
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_images/${image}`}
              className="post-body post-image"
            />
          )}
          {video && (
            <div className="post-body" ref={playerRef}>
              <div className="video-view">
                <div
                  className={
                    showOverlay
                      ? "alt-video-overlay"
                      : "alt-video-overlay-pause"
                  }
                >
                  <div className="left-controls">
                    <ul className="controls">
                      <VolumeGreen
                        className="Rac__volume"
                        onChange={(level) => {
                          const volume = level / 100;
                          videoRef.current.volume = volume;
                          videoRef.current.muted = volume === 0;
                        }}
                      />
                    </ul>
                  </div>
                  <ToggleButton
                    className="center-controls"
                    value={() => videoRef.current && !videoRef.current.paused}
                    onChange={(active) => {
                      if (!active) {
                        return videoRef.current.pause();
                      }

                      return videoRef.current.play();
                    }}
                  >
                    {(active) => {
                      if (
                        currentTime > 0.1 &&
                        currentTime < duration &&
                        active
                      ) {
                        setshowOverlay(true);
                        return (
                          <i
                            className="far fa-pause-circle green fa-3x"
                            onClick={() => videoRef.current.pause()}
                          ></i>
                        );
                      } else {
                        setshowOverlay(false);
                      }
                      if (currentTime === duration) {
                        setCurrentTime(0);
                      } else if (currentTime === 0 && !active) {
                        return (
                          <i
                            className="far fa-play-circle green fa-3x"
                            onClick={() => videoRef.current.play()}
                          ></i>
                        );
                      }
                      return (
                        <i
                          className="far fa-play-circle green fa-3x"
                          onClick={() => {
                            videoRef.current.play();
                          }}
                        ></i>
                      );
                    }}
                  </ToggleButton>
                  <ProgressGreen
                    className="Rac__progress-bar"
                    initial={0}
                    time={currentTime}
                    duration={duration}
                    onSkip={(time) => (videoRef.current.currentTime = time)}
                  />
                  <div className="icon-flex-expand-settings">
                    <ToggleButton
                      className="Rac__screen-toggle"
                      initial={document.fullscreenElement}
                      onChange={(active) => {
                        if (!active && KeyboardEvent.key === "Escape") {
                          return document.exitFullscreen();
                        }

                        return playerRef.current.requestFullscreen({
                          navigationUI: "hide",
                        });
                      }}
                    >
                      {(active) => {
                        if (!active) {
                          return (
                            <FontAwesomeIcon
                              icon="expand"
                              size="lg"
                              className="mt-4 green"
                            />
                          );
                        }

                        if (active) {
                          return (
                            <FontAwesomeIcon
                              icon="compress"
                              size="lg"
                              className="mt-4 green"
                            />
                          );
                        }
                      }}
                    </ToggleButton>
                  </div>
                </div>
                <video
                  ref={videoRef}
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_videos/${video}`}
                  className="fill-video"
                ></video>
              </div>
            </div>
          )}
          {text !== "" && (
            <div className="header-container">
              <div className="post-text">{text}</div>
            </div>
          )}
          <div className="post-footer">
            <div className="post-footer-icons">
              <ul className="footer-icons">
                <li className="footer-icon">
                  <i
                    className="far fa-thumbs-up fa-lg green"
                    onClick={() => addReaction(_id)}
                  ></i>
                  <span className="footer-icon-text">
                    {likes.length > 0 && <span>{likes.length}</span>}
                  </span>
                  <i className="far fa-thumbs-down fa-lg green mx-5"></i>
                </li>
                <li
                  className="footer-icon"
                  onClick={() => setShowComments(true)}
                >
                  <i className="far fa-comment fa-lg green"></i>
                  {comments.length > 0 && (
                    <span className="footer-icon-text">{comments.length}</span>
                  )}
                </li>
              </ul>
            </div>
            {showComments && (
              <div className="profile-comments">
                <p className="hide-comments">
                  <i
                    className="fas fa-comment-slash fa-lg mx-5 green cursor"
                    onClick={(e) => setShowComments(false)}
                  ></i>
                  <span
                    className="white cursor"
                    onClick={(e) => setShowComments(false)}
                  >
                    Hide Comments
                  </span>
                </p>
                <div className="comment-reply-input-container-alt">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (comment !== "") {
                        addPostComment({ comment, _id, user });
                        setComment("");
                      }
                    }}
                    className="comment-reply-input-hidden"
                  >
                    <input
                      type="text"
                      className="comment-reply-input"
                      name="comment"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Enter your comment here..."
                    />
                    <button className="comment-reply-input-button background-green">
                      <i className="far fa-comments"></i>
                    </button>
                  </form>
                </div>
                {comments.map((comment) => (
                  <PostCommentsItem
                    key={comment._id}
                    comment={comment}
                    channelid={channelid}
                    id={_id}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      {type === "article" && (
        <div className="profile-post">
          <div className="post-date">
            {!showModal && <i className="far fa-clock mr-5 mt-2 green"></i>}
            {!showModal && <Moment format="MM/DD/YYYY">{date}</Moment>}
            <i
              className="fas fa-ellipsis-v fa-lg post-info green"
              onClick={() => {
                if (showModal) {
                  setShowModal(false);
                } else {
                  setShowModal(true);
                }
              }}
            ></i>
          </div>
          <div className="post-header">
            <Link to={`/${channelid}`}>
              <div className="online-avi-container">
                <div className="avi-color-border green">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                    className="post-avi"
                  />
                </div>
              </div>
            </Link>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="side-container-user-item">{jobtitle}</li>
              </ul>
            </div>
          </div>
          <div>
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/article_images/${articleimage}`}
              className="post-body post-image cursor"
              onClick={(e) => setshowArticle(e)}
            />
          </div>
          {text !== "" && (
            <div className="header-container">
              <div className="post-text">{title}</div>
            </div>
          )}
          {keywords.length > 0 &&
            keywords[0].map((keyword) => (
              <li className="keywordsArray-alt green">{keyword}</li>
            ))}
          <div className="post-footer">
            <div className="post-footer-icons">
              <ul className="footer-icons-alt">
                <li className="footer-icon">
                  <i
                    className="far fa-thumbs-up fa-lg green"
                    onClick={() => addReaction(_id)}
                  ></i>
                  <span className="footer-icon-text">
                    {likes.length > 0 && <span>{likes.length}</span>}
                  </span>
                  <i className="far fa-thumbs-down fa-lg green mx-5"></i>
                </li>
                <li className="footer-icon">
                  <i
                    className="far fa-comment fa-lg green"
                    onClick={(e) => setShowComments(true)}
                  ></i>
                  <span
                    className="footer-icon-text"
                    onClick={(e) => setShowComments(true)}
                  >
                    {comments.length > 0 && (
                      <span className="footer-icon-text">
                        {comments.length}
                      </span>
                    )}
                  </span>
                </li>
                <li className="footer-icon">
                  <i
                    className="fas fa-book-open fa-lg green"
                    onClick={(e) => setshowArticle(e)}
                  ></i>
                  <span
                    className="footer-icon-text"
                    onClick={(e) => setshowArticle(e)}
                  >
                    Read
                  </span>
                </li>
              </ul>
            </div>
            {showComments && (
              <div className="profile-comments">
                <p className="hide-comments">
                  <i
                    className="fas fa-comment-slash fa-lg mx-5 green cursor"
                    onClick={(e) => setShowComments(false)}
                  ></i>
                  <span
                    className="white cursor"
                    onClick={(e) => setShowComments(false)}
                  >
                    Hide Comments
                  </span>
                </p>
                <div className="comment-reply-input-container-alt">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (comment !== "") {
                        addPostComment({ comment, _id });
                        setComment("");
                      }
                    }}
                    className="comment-reply-input-hidden"
                  >
                    <input
                      type="text"
                      className="comment-reply-input"
                      name="comment"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Enter your comment here..."
                    />
                    <button className="comment-reply-input-button background-green">
                      <i className="far fa-comments"></i>
                    </button>
                  </form>
                </div>
                {comments.map((comment) => (
                  <ProfileArticlePostComment
                    key={comment._id}
                    comment={comment}
                    id={_id}
                  />
                ))}
              </div>
            )}
            {showArticle && (
              <PublishedArticle
                _id={_id}
                avatar={avatar}
                firstname={firstname}
                lastname={lastname}
                jobtitle={jobtitle}
                location={location}
                addReaction={addReaction}
                likes={likes}
                comments={comments}
                comment={comment}
                setshowArticle={setshowArticle}
                addPostComment={addPostComment}
                setComment={setComment}
                keywords={keywords}
                blocks={blocks}
                articleimage={articleimage}
                title={title}
                date={date}
              />
            )}
          </div>
        </div>
      )}
      {type === "mentorpost" && (
        <div className="profile-post">
          <div className="post-top-container">
            <div className="post-type red">Post</div>
            <div className="post-date">
              {!showModal && <i className="far fa-clock mr-5 mt-2 red"></i>}
              {!showModal && <Moment format="MM/DD/YYYY">{date}</Moment>}
              <i
                className="fas fa-ellipsis-v fa-lg post-info red"
                onClick={() => {
                  if (showModal) {
                    setShowModal(false);
                  } else {
                    setShowModal(true);
                  }
                }}
              ></i>
            </div>
          </div>
          <div className="post-header">
            <Link to={`/${channelid}`}>
              <div className="online-avi-container">
                <div className="avi-color-border red">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                    className="post-avi"
                  />
                </div>
              </div>
            </Link>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="side-container-user-item">{jobtitle}</li>
              </ul>
            </div>
          </div>
          {image && (
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_images/${image}`}
              className="post-body post-image"
            />
          )}
          {video && (
            <div className="post-body" ref={playerRef}>
              <div className="video-view">
                <div
                  className={
                    showOverlay
                      ? "alt-video-overlay"
                      : "alt-video-overlay-pause"
                  }
                >
                  <div className="left-controls">
                    <ul className="controls">
                      <VolumeRed
                        className="Rac__volume"
                        onChange={(level) => {
                          const volume = level / 100;
                          videoRef.current.volume = volume;
                          videoRef.current.muted = volume === 0;
                        }}
                      />
                    </ul>
                  </div>
                  <ToggleButton
                    className="center-controls"
                    value={() => videoRef.current && !videoRef.current.paused}
                    onChange={(active) => {
                      if (!active) {
                        return videoRef.current.pause();
                      }

                      return videoRef.current.play();
                    }}
                  >
                    {(active) => {
                      if (
                        currentTime > 0.1 &&
                        currentTime < duration &&
                        active
                      ) {
                        setshowOverlay(true);
                        return (
                          <i
                            className="far fa-pause-circle red fa-3x"
                            onClick={() => videoRef.current.pause()}
                          ></i>
                        );
                      } else {
                        setshowOverlay(false);
                      }
                      if (currentTime === duration) {
                        setCurrentTime(0);
                      } else if (currentTime === 0 && !active) {
                        return (
                          <i
                            className="far fa-play-circle red fa-3x"
                            onClick={() => videoRef.current.play()}
                          ></i>
                        );
                      }
                      return (
                        <i
                          className="far fa-play-circle red fa-3x"
                          onClick={() => {
                            videoRef.current.play();
                          }}
                        ></i>
                      );
                    }}
                  </ToggleButton>
                  <ProgressRed
                    className="Rac__progress-bar"
                    initial={0}
                    time={currentTime}
                    duration={duration}
                    onSkip={(time) => (videoRef.current.currentTime = time)}
                  />
                  <div className="icon-flex-expand-settings">
                    <ToggleButton
                      className="Rac__screen-toggle"
                      initial={document.fullscreenElement}
                      onChange={(active) => {
                        if (!active && KeyboardEvent.key === "Escape") {
                          return document.exitFullscreen();
                        }

                        return playerRef.current.requestFullscreen({
                          navigationUI: "hide",
                        });
                      }}
                    >
                      {(active) => {
                        if (!active) {
                          return (
                            <FontAwesomeIcon
                              icon="expand"
                              size="lg"
                              className="mt-4 red"
                            />
                          );
                        }

                        if (active) {
                          return (
                            <FontAwesomeIcon
                              icon="compress"
                              size="lg"
                              className="mt-4 red"
                            />
                          );
                        }
                      }}
                    </ToggleButton>
                  </div>
                </div>
                <video
                  ref={videoRef}
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_videos/${video}`}
                  className="fill-video"
                ></video>
              </div>
            </div>
          )}
          {text !== "" && (
            <div className="header-container">
              <div className="post-text">{text}</div>
            </div>
          )}
          <div className="post-footer">
            <div className="post-footer-icons">
              <ul className="footer-icons">
                <li className="footer-icon">
                  <i
                    className="far fa-thumbs-up fa-lg red"
                    onClick={() => addReaction(_id)}
                  ></i>
                  <span className="footer-icon-text">
                    {likes.length > 0 && <span>{likes.length}</span>}
                  </span>
                  <i className="far fa-thumbs-down fa-lg red mx-5"></i>
                </li>
                <li
                  className="footer-icon"
                  onClick={(e) => setShowComments(true)}
                >
                  <i className="far fa-comment fa-lg red"></i>
                  {comments.length > 0 && (
                    <span className="footer-icon-text">{comments.length}</span>
                  )}
                </li>
              </ul>
            </div>
            {showComments && (
              <div className="profile-comments">
                <p className="hide-comments">
                  <i
                    className="fas fa-comment-slash fa-lg mx-5 red cursor"
                    onClick={(e) => setShowComments(false)}
                  ></i>
                  <span
                    className="white cursor"
                    onClick={(e) => setShowComments(false)}
                  >
                    Hide Comments
                  </span>
                </p>
                {user && user.role !== "employer" && (
                  <div className="comment-reply-input-container-alt">
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        if (comment !== "") {
                          addPostComment({ comment, _id });
                          setComment("");
                        }
                      }}
                      className="comment-reply-input-hidden"
                    >
                      <input
                        type="text"
                        className="comment-reply-input"
                        name="comment"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Enter your comment here..."
                      />
                      <button className="comment-reply-input-button background-red">
                        <i className="far fa-comments"></i>
                      </button>
                    </form>
                  </div>
                )}
                {comments.map((comment) => (
                  <MentorProfileCommentsItem
                    key={comment._id}
                    comment={comment}
                    id={_id}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      {type === "employerpost" && user && user.role === "employer" && (
        <div className="profile-post">
          <div className="post-date">
            {!showModal && <i className="far fa-clock mr-5 mt-2 blue"></i>}
            {!showModal && <Moment format="MM/DD/YYYY">{date}</Moment>}
            <i
              className="fas fa-ellipsis-v fa-lg post-info blue"
              onClick={() => {
                if (showModal) {
                  setShowModal(false);
                } else {
                  setShowModal(true);
                }
              }}
            ></i>
          </div>
          <div className="post-header">
            <Link to={`/${channelid}`}>
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                    className="post-avi"
                  />
                </div>
              </div>
            </Link>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font bold">{companyname}</span>
                </li>
                <li className="side-container-user-item">
                  {firstname} {lastname}
                </li>
              </ul>
            </div>
          </div>
          {image && (
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_images/${image}`}
              className="post-body post-image"
            />
          )}
          {video && (
            <div className="post-body">
              <div className="video-view">
                <div
                  className={
                    showOverlay
                      ? "alt-video-overlay"
                      : "alt-video-overlay-pause"
                  }
                >
                  <div className="left-controls">
                    <ul className="controls">
                      <Volume
                        className="Rac__volume"
                        initial={0}
                        onChange={(level) => {
                          const volume = level / 100;
                          videoRef.current.volume = volume;
                          videoRef.current.muted = volume === 0;
                        }}
                      />
                    </ul>
                  </div>
                  <ToggleButton
                    className="center-controls"
                    value={() => videoRef.current && !videoRef.current.paused}
                    onChange={(active) => {
                      if (!active) {
                        return videoRef.current.pause();
                      }

                      return videoRef.current.play();
                    }}
                  >
                    {(active) => {
                      if (
                        currentTime > 0.1 &&
                        currentTime < duration &&
                        active
                      ) {
                        setshowOverlay(true);
                        return (
                          <i
                            className="far fa-pause-circle blue fa-3x"
                            onClick={() => videoRef.current.pause()}
                          ></i>
                        );
                      } else {
                        setshowOverlay(false);
                      }
                      if (currentTime === duration) {
                        setCurrentTime(0);
                      } else if (currentTime === 0 && !active) {
                        return (
                          <i
                            className="far fa-play-circle blue fa-3x"
                            onClick={() => videoRef.current.play()}
                          ></i>
                        );
                      }
                      return (
                        <i
                          className="far fa-play-circle blue fa-3x"
                          onClick={() => videoRef.current.play()}
                        ></i>
                      );
                    }}
                  </ToggleButton>
                  <Progress
                    className="Rac__progress-bar"
                    initial={0}
                    time={currentTime}
                    duration={duration}
                    onSkip={(time) => (videoRef.current.currentTime = time)}
                  />
                </div>
                <video
                  ref={videoRef}
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_videos/${video}`}
                  className="fill-video"
                ></video>
              </div>
            </div>
          )}
          {text !== "" && (
            <div className="header-container">
              <div className="post-text">{text}</div>
            </div>
          )}
          <div className="post-footer">
            <div className="post-footer-icons">
              <ul className="footer-icons">
                <li className="footer-icon">
                  <i
                    className="far fa-thumbs-up fa-lg blue"
                    onClick={() => addReaction(_id)}
                  ></i>
                  <span className="footer-icon-text">
                    {likes.length > 0 && <span>{likes.length}</span>}
                  </span>
                  <i className="far fa-thumbs-down fa-lg blue mx-5"></i>
                </li>
                <li
                  className="footer-icon"
                  onClick={(e) => setShowComments(true)}
                >
                  <i className="far fa-comment fa-lg blue"></i>
                  {comments.length > 0 && (
                    <span className="footer-icon-text">{comments.length}</span>
                  )}
                </li>
              </ul>
            </div>
            {showComments && (
              <div className="profile-comments">
                <p className="hide-comments">
                  <i
                    className="fas fa-comment-slash fa-lg mx-5 blue cursor"
                    onClick={() => setShowComments(false)}
                  ></i>
                  <span
                    className="white cursor"
                    onClick={() => setShowComments(false)}
                  >
                    Hide Comments
                  </span>
                </p>
                <div className="comment-reply-input-container-alt">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (comment !== "") {
                        addPostComment({ comment, _id });
                        setComment("");
                      }
                    }}
                    className="comment-reply-input-hidden"
                  >
                    <input
                      type="text"
                      className="comment-reply-input"
                      name="comment"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Enter your comment here..."
                    />
                    <button className="comment-reply-input-button background-blue">
                      <i className="far fa-comments"></i>
                    </button>
                  </form>
                </div>
                {comments.map((comment) => (
                  <EmployerCommentsItem
                    key={comment._id}
                    comment={comment}
                    id={_id}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      {type === "vrtour" && (
        <div className="profile-post">
          <div className="post-date">
            {!showModal && <i className="far fa-clock mr-5 mt-2 blue"></i>}
            {!showModal && <Moment format="MM/DD/YYYY">{date}</Moment>}
            <i
              className="fas fa-ellipsis-v fa-lg post-info blue"
              onClick={() => {
                if (showModal) {
                  setShowModal(false);
                } else {
                  setShowModal(true);
                }
              }}
            ></i>
          </div>
          <div className="post-header">
            <Link to={`/${channelid}`}>
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                    className="post-avi"
                  />
                </div>
              </div>
            </Link>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">{companyname}</span>
                </li>
                <li className="side-container-user-item">
                  {firstname} {lastname}
                </li>
              </ul>
            </div>
          </div>
          <div className="post-body">
            <div className="video-view">
              <div
                className={
                  showOverlay ? "alt-video-overlay" : "alt-video-overlay-pause"
                }
              >
                <div className="video-live blue">
                  <i className="fas fa-street-view fa-2x blue"></i>
                </div>
                <div className="left-controls">
                  <ul className="controls">
                    <Volume
                      className="Rac__volume"
                      initial={0}
                      onChange={(level) => {
                        const volume = level / 100;
                        videoRef.current.volume = volume;
                        videoRef.current.muted = volume === 0;
                      }}
                    />
                  </ul>
                </div>
                <ToggleButton
                  className="center-controls"
                  value={() => videoRef.current && !videoRef.current.paused}
                  onChange={(active) => {
                    if (!active) {
                      return videoRef.current.pause();
                    }

                    return videoRef.current.play();
                  }}
                >
                  {(active) => {
                    if (currentTime > 0.1 && currentTime < duration && active) {
                      setshowOverlay(true);
                      return (
                        <i
                          className="far fa-pause-circle blue fa-3x"
                          onClick={() => videoRef.current.pause()}
                        ></i>
                      );
                    } else {
                      setshowOverlay(false);
                    }
                    if (currentTime === duration) {
                      setCurrentTime(0);
                    } else if (currentTime === 0 && !active) {
                      return (
                        <i
                          className="far fa-play-circle blue fa-3x"
                          onClick={() => videoRef.current.play()}
                        ></i>
                      );
                    }
                    return (
                      <i
                        className="far fa-play-circle blue fa-3x"
                        onClick={() => videoRef.current.play()}
                      ></i>
                    );
                  }}
                </ToggleButton>
                <Progress
                  className="Rac__progress-bar"
                  initial={0}
                  time={currentTime}
                  duration={duration}
                  onSkip={(time) => (videoRef.current.currentTime = time)}
                />
              </div>
              <video
                ref={videoRef}
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/vr_tour_videos/${video}`}
                className="fill-video"
              ></video>
            </div>
          </div>
          {description !== "" && (
            <div className="header-container">
              <div className="post-text">{description}</div>
            </div>
          )}
          <div className="post-footer">
            <div className="post-footer-icons">
              <ul className="footer-icons-alt">
                <li className="footer-icon">
                  <i
                    className="far fa-thumbs-up fa-lg blue"
                    onClick={() => addReaction(_id)}
                  ></i>
                  <span className="footer-icon-text mx-5">
                    {likes.length > 0 && <span>{likes.length}</span>}
                  </span>
                  <i className="far fa-thumbs-down fa-lg blue"></i>
                </li>
                <li className="footer-icon">
                  <i className="far fa-user fa-lg blue"></i>
                  <span className="footer-icon-text">54.9k</span>
                </li>
                <li className="footer-icon">
                  <i className="fas fa-play-circle fa-lg blue"></i>
                  <span className="footer-icon-text">Watch</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

PostItem.propTypes = {
  auth: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  addReaction: PropTypes.func.isRequired,
  removeLike: PropTypes.func.isRequired,
  addPostComment: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  addReaction,

  addPostComment,
})(PostItem);
